import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type { CouponQuery, Coupon } from './types';

/**
 * 分页查询优惠券列表
 */
export const getCouponPage = (params: CouponQuery): AxiosPromise<Coupon[]> => {
  return request({
    url: '/api/order/coupon/page',
    method: 'get',
    params
  });
};
